import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { Button } from '@/shared/ui';

import styles from './CookieBanner.module.css';

/** Storage key that remembers the banner was acknowledged. */
export const cookieNoticeKey = 'nazubke.cookie-notice';

function acknowledged(): boolean {
  try {
    return localStorage.getItem(cookieNoticeKey) === '1';
  } catch {
    return false;
  }
}

/**
 * Tells visitors which cookies are set. Only necessary ones exist today, so
 * there is nothing to opt out of; a consent choice is added together with the
 * first analytics cookie. Not shown while studying, where the rating buttons
 * own the bottom of the screen.
 */
export function CookieBanner(): React.JSX.Element | null {
  const { t } = useTranslation();
  const [hidden, setHidden] = useState(acknowledged);
  const { pathname } = useLocation();

  if (hidden || pathname.startsWith('/review/')) {
    return null;
  }

  return (
    <div className={styles.banner} role="region" aria-label="cookies">
      <p>
        {t('cookies.text')} <Link to="/privacy">{t('cookies.more')}</Link>
      </p>
      <Button
        variant="primary"
        onClick={() => {
          try {
            localStorage.setItem(cookieNoticeKey, '1');
          } catch {
            // Without storage the banner simply shows again next visit.
          }
          setHidden(true);
        }}
      >
        {t('cookies.accept')}
      </Button>
    </div>
  );
}
